var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraffic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_13742)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_13742",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1253 0.803223H0.232422V26.5711H21.1253V0.803223Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_13742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4492 0.803223H6.9089C6.38893 0.804756 5.96793 1.21582 5.96636 1.7235V25.6508C5.96793 26.1585 6.38893 26.5695 6.9089 26.5711H14.4492C14.9691 26.5695 15.3901 26.1585 15.3917 25.6508V1.7235C15.3901 1.21582 14.9691 0.804756 14.4492 0.803223ZM10.679 24.2704C9.53543 24.2704 8.50414 23.5978 8.06664 22.5663C7.62915 21.5348 7.87107 20.3469 8.67929 19.5578C9.4883 18.7686 10.7042 18.5317 11.7606 18.9596C12.817 19.3868 13.5059 20.3937 13.5059 21.5103C13.5059 23.0349 12.2397 24.2711 10.6782 24.2711L10.679 24.2704ZM10.679 16.448C9.53543 16.448 8.50414 15.7754 8.06664 14.7439C7.62915 13.7125 7.87107 12.5245 8.67929 11.7354C9.4883 10.9462 10.7042 10.7093 11.7606 11.1372C12.817 11.5644 13.5059 12.5713 13.5059 13.6879C13.5059 15.2125 12.2397 16.4488 10.6782 16.4488L10.679 16.448ZM10.679 8.62561C9.53543 8.62561 8.50414 7.95304 8.06664 6.92155C7.62915 5.89007 7.87107 4.70214 8.67929 3.913C9.4883 3.12386 10.7042 2.88689 11.7606 3.31482C12.817 3.74199 13.5059 4.74893 13.5059 5.86553C13.5059 7.39013 12.2397 8.62637 10.6782 8.62637L10.679 8.62561ZM5.02383 3.10392V8.16547C3.10812 7.06803 1.50739 5.51736 0.367703 3.65609C0.212971 3.42219 0.379485 3.11236 0.664602 3.10392H5.02383ZM5.02383 10.9263V15.9879C3.10812 14.8904 1.50739 13.3397 0.367703 11.4785C0.212971 11.2446 0.379485 10.9347 0.664602 10.9263H5.02383ZM5.02383 18.7487V23.8102C3.10812 22.7128 1.50739 21.1621 0.367703 19.3009C0.212971 19.067 0.379485 18.7571 0.664602 18.7487H5.02383ZM20.9904 3.65609C19.8507 5.51736 18.2499 7.06803 16.3342 8.16547V3.10392H20.6935C20.9786 3.11236 21.1451 3.42219 20.9904 3.65609ZM20.9904 11.4785C19.8507 13.3397 18.2499 14.8904 16.3342 15.9879V10.9263H20.6935C20.9786 10.9347 21.1451 11.2446 20.9904 11.4785ZM20.9904 19.3009C19.8507 21.1621 18.2499 22.7128 16.3342 23.8102V18.7487H20.6935C20.9786 18.7571 21.1451 19.067 20.9904 19.3009Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_13742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8929,
    height: 25.7679,
    fill: "white",
    transform: "translate(0.232422 0.803223)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffic);
export default __webpack_public_path__ + "static/media/traffic.9981e86ab135a938999b1fb8585cbb8d.svg";
export { ForwardRef as ReactComponent };